import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import { alpha } from '@mui/material/styles';
import { colors } from '@mui/material';
import {ReactComponent as PostgresqlIcon} from '../../assets/svg/postgresql.svg';
import {ReactComponent as JavaIcon} from '../../assets/svg/java.svg';
import {ReactComponent as GolangIcon} from '../../assets/svg/golang.svg';
import {ReactComponent as PythonIcon} from '../../assets/svg/python.svg';
import {ReactComponent as AndroidIcon} from '../../assets/svg/android.svg';
import {ReactComponent as AngularJSIcon} from '../../assets/svg/angularjs.svg';
import {ReactComponent as ReactIcon} from '../../assets/svg/react.svg';
import {ReactComponent as BackendIcon} from '../../assets/svg/backend.svg';
import {ReactComponent as FrontendIcon} from '../../assets/svg/frontend.svg';
import {ReactComponent as DevopsIcon} from '../../assets/svg/devops.svg';

const mockup = [
    {
      color: colors.lightBlue[500],
      title: 'Frontend',
      subtitle: 'Step by step guide to becoming a modern frontend developer in 2022.',
      link: 'https://roadmap.sh/frontend',
      icon: <FrontendIcon />,
    },
    {
      color: colors.purple[500],
      title: 'Backend',
      subtitle: 'Step by step guide to becoming a modern backend developer in 2022.',
      link: 'https://roadmap.sh/backend',
      icon: <BackendIcon />,
    },
    {
      color: colors.yellow[500],
      title: 'DevOps',
      subtitle: 'Step by step guide for DevOps, SRE or any other Operations Role in 2022.',
      link: 'https://roadmap.sh/devops',
      icon: <DevopsIcon />,
    },
    {
      color: colors.indigo[500],
      title: 'React',
      subtitle: 'Everything that is there to learn about React and the ecosystem in 2022.',
      link: 'https://roadmap.sh/react',
      icon: <ReactIcon />,
    },
    {
      color: colors.red[500],
      title: 'Angular',
      subtitle: 'Everything that is there to learn about Angular and the ecosystem in 2022.',
      link: 'https://roadmap.sh/angular',
      icon: <AngularJSIcon />,
    },
    {
      color: colors.green[500],
      title: 'Android',
      subtitle: 'Step by step guide to becoming an Android developer in 2022.',
      link: 'https://roadmap.sh/android',
      icon:<AndroidIcon />,
    },
    {
      color: colors.orange[500],
      title: 'Python',
      subtitle: 'Step by step guide to becoming a Python developer in 2022.',
      link: 'https://roadmap.sh/python',
      icon: <PythonIcon />,
    },
    {
      color: colors.lightBlue[500],
      title: 'Go',
      subtitle: 'Step by step guide to becoming a Go developer in 2022.',
      link: 'https://roadmap.sh/golang',
      icon: (<GolangIcon />),
    },
    {
      color: colors.blue[500],
      title: 'Java',
      subtitle: 'Step by step guide to becoming a Java developer in 2022.',
      link: 'https://roadmap.sh/java',
      icon: <JavaIcon />,
    },
    {
      color: colors.blueGrey[500],
      title: 'PostgreSQL DBA',
      subtitle: 'Step by step guide to becoming a modern PostgreSQL DB Administrator in 2022.',
      link: 'https://roadmap.sh/postgresql-dba',
      icon: <PostgresqlIcon />,
    },
  ];

const RoadMapCards = () => {
  return (
    <Box >
        <Box marginBottom={4}>
          <Box marginBottom={2}>
            <Typography
              variant="h4"
              color="text.primary"
              align={'center'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
            >
              Choose the pathway to master your desired field
            </Typography>

            <Typography
              variant="h6"
              component="p"
              color="text.secondary"
              sx={{ fontWeight: 400 }}
              align={'center'}
            >
              Contributed by developers for developers
            </Typography>
            <Typography
              variant="h6"
              component="p"
              color="text.secondary"
              sx={{ fontWeight: 400 }}
              align={'center'}
            >
              Step by step guides and paths to learn different tools or technologies
            </Typography>
          </Box>
        </Box>
        <Grid  container spacing={4}>
          {mockup.map((item, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Box
                display={'block'}
                width={1}
                height={1}
                sx={{
                  textDecoration: 'none',
                  transition: 'all .2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                  },
                }}
              >
                <Box component={Card} padding={4} width={1} height={1}>
                  <Box display={'flex'} flexDirection={'column'}>
                    <Box
                      component={Avatar}
                      width={60}
                      height={60}
                      marginBottom={2}
                      bgcolor={alpha(item.color, 0.1)}
                      color={item.color}
                      variant={'rounded'}
                    >
                      {item.icon}
                    </Box>
                    <Typography
                      variant={'h6'}
                      gutterBottom
                      sx={{ fontWeight: 700 }}
                    >
                      {item.title}
                    </Typography>
                    <Typography color="text.secondary">
                      {item.subtitle}
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box
                      marginTop={2}
                      display={'flex'}
                      justifyContent={'flex-end'}
                      component={'a'}
                      href={item.link}
                      target={'_blank'}
                    >
                      <Button
                        endIcon={
                          <Box
                            component={'svg'}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            width={24}
                            height={24}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17 8l4 4m0 0l-4 4m4-4H3"
                            />
                          </Box>
                        }
                      >
                        Learn More
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))}
             <Grid item xs={12} sm={6} md={4}>
                <Box 
                  display={'flex'} 
                  alignItems={'center'} 
                  component={Card} 
                  padding={4} 
                  width={1} 
                  height={1}
                  minHeight={'300px'}
                  style={{
                    filter: 'blur(1.1px)',
                  }}
                >
                  <Box display={'flex'} flexDirection={'column'} >
                    <Typography
                      variant={'h6'}
                      gutterBottom
                      sx={{ fontWeight: 700 }}
                    >
                      Coming soon
                    </Typography>
                    <Typography color="text.secondary">
                       New roadmaps will be updated...
                    </Typography>

                  </Box>
                </Box>
              </Grid>
        </Grid>

    </Box>
  );
};

export default RoadMapCards;